import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '../../services/wealthlane-award-services';

const useGetAllRecordTypeList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const AllRecordTypeList = useQuery(
    ['getAllRecordTypeList'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesRecordTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return AllRecordTypeList;
};

export default useGetAllRecordTypeList;
